export default __webpack_public_path__ + "static/media/connectivity-full-HD.8599de46.jpg";